<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  props: {
    width: {
      type: Number,
      default: 7
    }
  },
  mounted() {
    Vue.nextTick(() => {
      if (this.$el.getElementsByTagName('iframe').length > 0) {
        window.addEventListener("message", (event) => {
          if (event.origin !== "https://s3-eu-west-1.amazonaws.com" && event.origin !== "https://it-business.vodafone.com")
            return;

          console.log("Event: ",event);
          console.log("Data: ", event.data);
          if (!!window.wa_gc) {
            const digitalData = Fandom.deepClone(window.digitalData);
            digitalData.page.pageInfo.pageName += ":TYP";
            wa_gc(digitalData, 'view');
            console.log("%cExecuted wa_gc(digitalData, 'view')", "background: #222; color: #bada55; padding: .5rem;", digitalData);
          }
          if (event.data.message == "thank-you-page-button-clicked") {
            const target = get(globalState.pageModel, ['user', 'target', 0], false);
            let redirectUrl = '/'
            if (target) {
              redirectUrl = VodafoneLab.targetTagToUrl[target] || '/';
            }
            window.location.href = redirectUrl;
          } else if (!!event.data.height && event.data.message == "thank-you-page-loaded") {
            document.getElementById('contactIFrame').setAttribute('height', event.data.height);
          }
        }, false);
      }
    });
  },
  methods: {
    expandUrl: Fandom.expandUrl,
    exists: Fandom.exists,
    scrollToEnd() {
      Fandom.scrollToBottom(`one-col-${this.containerContent.id}_${this.content.$id}`, 56);
    }
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.width;
      return [
        `col-lg-${columnWidth}`,
        `text-${this.content.text_align}`
      ];
    },
    componentClasses() {
      const classes = [
        this.contentType, 
      ]
      if (!!this.content.background_class && !this.content.background_color) {
        classes.push(this.content.background_class.indexOf("bg-") >= 0 ? this.content.bakcground_class : `bg-${this.content.background_class}`);
      }
      if (!!this.content.section_title) {
        classes.push('pb-0');
      }
      return classes;
    },
    containerClasses() {
      return [
        Fandom.exists(this.content.background_fixed) && this.content.background_fixed && !this.isViewportMobile ? "bg-fixed" : "bg-cover-center",
        this.content.theme ? `${this.content.theme}-theme` : ""
      ];
    },
    containerStyles() {
      return {
        "min-height": this.content.height,
        "color": this.content.text_color
      };
    },
    isViewportMobile() {
      return globalState.viewport.sm || globalState.viewport.xs || globalState.viewport.md;
    }
  },
};

</script>

<template>
  <div :id="`one-col-${containerContent.id}_${content.$id}`" v-easyadmin="easyadminId" :class="componentClasses" v-if="isContentVisibleToUser()" class="py-3 position-relative" :style="{'background-color': content.background_color }" one-col-component>
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container google-seo-height d-flex flex-column justify-content-center overflow-hidden" :style="containerStyles">
      <div 
        class="position-absolute-center bg-cover-center w-100 h-100"
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
      ></div>
      <div class="row text-align-center justify-content-center">
        <div :class="columnClasses">
          <text-section :content="content" :opt-container-content="containerContent"></text-section>
          <div class="w-100 d-flex justify-content-center align-items-center text-primary mt-4 pt-2" v-if="content.scroll_down">
            <div class="cursor-pointer text-center" @click="scrollToEnd">
              <div>{{content.scroll_down}}</div>
              <i class="fal fa-chevron-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[one-col-component] {

  /*TODO: to remove after fixed in variables file*/
  $secondary-nav-height: 48px;

  table {
    @include font-size(1rem);
    font-weight: 600;
  }

  .anchor {
    display: block;
    height: calc(#{$header-height-sm} + #{$secondary-nav-height});
    margin-top:  calc(-#{$header-height-sm} - #{$secondary-nav-height});
    visibility: hidden;
  }

}
</style>
